<template>
    <div>
        <v-row>
            <v-col class="pb-0" cols="12" sm="12" md="4" lg="3">
              <div :style="showLine">
                <LeftPerfil
                    ref="left"
                    @changeButton="changeIndex"
                    :index="index"
                />
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="9" :class="$vuetify.breakpoint.xs ? 'pt-0 pb-2': 'pb-10'">
              
                <RightPerfil
                    style="height: 100%"
                    ref="right"
                    :index="index"
                    @changeIndex="changeIndex"
                    @complete="complete()"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import LeftPerfil from './Shared/LeftPerfil'
import RightPerfil from './Shared/RightPerfil'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    LeftPerfil,
    RightPerfil
  },
  data () {
    return {
      index: 0,
      linhaVertical: {
        'border-right': '1px solid #DEE2E6',
        'height': '100%'
      }
    }
  },
  beforeMount () {
    this.$emit('cancelar')
    EventBus.$emit('changeIndexPerfil', this.index)
  },
  methods: {
    validarMudanca () {
      this.$refs.right.validarMudanca()
    },
    closeError () {
      this.showError = false
      this.$router.push('/home')
    },
    complete () {
      this.$refs.left.changeDisabled()
    },
    saveVersao () {
      this.$refs.right.salvarVersao()
    },
    backStep () {
      if (this.index >= 0) {
        this.index--
      }
    },
    changeIndex (index) {
      this.index = index
      EventBus.$emit('changeIndexPerfil', index)
    }
  },
  computed: {
    showLine () {
      return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? this.linhaVertical : ''
    }
  }
}
</script>

<style lang="sass" scoped>
.linha
    border-top: 1px solid #DEE2E6
    width: 98%
    margin: 5px 0
</style>
